import type { MaterialPublicDto, ProductPublicDto } from "@sticker-giant/sg-frontend-common";
import type { SizeConstraints } from "@/lib/product/customSizeValidation";

export function getSizeConstraints(
  materialOption: MaterialPublicDto | undefined,
  productAdmin: ProductPublicDto | undefined,
): SizeConstraints {
  return {
    minWidth: materialOption?.minWidth ?? productAdmin?.minCustomWidth ?? 0.5,
    maxWidth: materialOption?.maxWidth ?? productAdmin?.maxCustomWidth ?? 11,
    minHeight: materialOption?.minHeight ?? productAdmin?.minCustomHeight ?? 0.5,
    maxHeight: materialOption?.maxHeight ?? productAdmin?.maxCustomHeight ?? 14,
  };
}

export function filterSizeOptionsByConstraints<Size extends { width: number; height: number }>(
  sizeOptions: Size[],
  { minWidth, maxWidth, minHeight, maxHeight }: SizeConstraints,
): Size[] {
  return sizeOptions.filter(size => {
    const fitsNormal =
      size.width >= minWidth && size.width <= maxWidth && size.height >= minHeight && size.height <= maxHeight;
    const fitsRotated =
      size.height >= minWidth && size.height <= maxWidth && size.width >= minHeight && size.width <= maxHeight;
    return fitsNormal || fitsRotated;
  });
}
